import React from "react";
import {
	ModalLabel,
	ModalTitle,
	Modal,
	Button,
	AmountWrapper,
	ExpiredText,
	ExpiredDate,
} from "./SpinBonusModal.style";
import { useTranslation } from "react-i18next";
import { getFormattedNumber } from "@utils";
import moment from "moment";

const SpinBonusModal = ({ open, handleClose, amount, bonus_expired }) => {
	const { t } = useTranslation();

	return (
		<>
			<Modal
				open={open}
				closable={false}
				footer={null}
				style={{
					textAlign: "center",
				}}
				centered={true}
				onCancel={handleClose}
				width={365}
				height={423}
			>
				<ModalTitle>{t("spin.spinWinningTitle")}</ModalTitle>
				<ModalLabel>{t("spin.spinWinningSubTitle")}</ModalLabel>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
					}}
				>
					<AmountWrapper>{`${getFormattedNumber(
						amount ?? 0
					)} Ks.`}</AmountWrapper>
				</div>
				<ExpiredText
					style={{
						visibility: bonus_expired ? "visible" : "hidden",
					}}
				>
					{t("spin.expiredMessage")}
					<ExpiredDate>
						{moment.unix(bonus_expired).format("D MMMM YYYY")}
					</ExpiredDate>
				</ExpiredText>
				<Button onClick={handleClose}>{t("common.ok")}</Button>
			</Modal>
		</>
	);
};

export default SpinBonusModal;
